var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"d-flex justify-center align-center",attrs:{"fill-height":""}},[_c('h2',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.$lang("ERRORS:NOT_FOUND:TITLE-TEXT")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }